"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupCouponsByStatus = exports.getCheckPassword = void 0;
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const regExp_1 = require("../../utils/regExp");
const types_1 = require("./types");
const constants_1 = require("./constants");
const getCheckPassword = ({ newPassword, confirmPassword, oldPassword, }) => {
    let errors = [];
    errors = (0, regExp_1.regExpCheckPassword)(newPassword);
    if (!new RegExp(regExp_1.REG_PASSWORD_SEPARATED.symbolsCounts).test(oldPassword) &&
        !!oldPassword.length) {
        errors.push({
            type: types_1.EChangePassword.OLD,
            text: 'at least 6 characters',
        });
    }
    if (!(0, react_fast_compare_1.default)(newPassword, confirmPassword)) {
        errors.push({
            type: types_1.EChangePassword.CONFIRM,
            text: 'entered passwords do not match',
        });
    }
    if (!newPassword.length) {
        errors.push({
            type: types_1.EChangePassword.RENEWED,
            text: '',
        });
    }
    if (!confirmPassword.length) {
        errors.push({
            type: types_1.EChangePassword.CONFIRM,
            text: '',
        });
    }
    if (!oldPassword.length) {
        errors.push({
            type: types_1.EChangePassword.OLD,
            text: '',
        });
    }
    return errors;
};
exports.getCheckPassword = getCheckPassword;
const groupCouponsByStatus = (coupons) => {
    const result = {
        [types_1.ELoyaltyStatus.ACTIVE]: [],
        [types_1.ELoyaltyStatus.ALL]: [],
        [types_1.ELoyaltyStatus.ARCHIVE]: [],
    };
    coupons.forEach((coupon) => {
        if (!coupon.status)
            return;
        if (constants_1.LOYALTY_ALL_STATUS.includes(coupon.status)) {
            result[types_1.ELoyaltyStatus.ALL].push(coupon);
        }
        if (constants_1.LOYALTY_ACTIVE_STATUS.includes(coupon.status)) {
            result[types_1.ELoyaltyStatus.ACTIVE].push(coupon);
        }
        if (constants_1.LOYALTY_ARCHIVE_STATUS.includes(coupon.status)) {
            result[types_1.ELoyaltyStatus.ARCHIVE].push(coupon);
        }
    });
    return result;
};
exports.groupCouponsByStatus = groupCouponsByStatus;
//# sourceMappingURL=utils.js.map